import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-4 py-6" data-id="element-40" data-mp="1hdbdhlshjf57">
      <div className="mx-auto max-w-3xl" data-id="element-41" data-mp="1he2y61kjnsgp">
        <h2 className="text-center text-xl text-espresso sm:text-3xl" data-id="element-42" data-mp="1cehx9lltda1c">
          Frequently Asked <span className="text-burnt" data-id="element-43" data-mp="1ccnh0klhm63l">Questions</span>
        </h2>
        <ul className="mt-3 space-y-1.5" data-id="element-44" data-mp="2a1qidfhwkh2t">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} className="overflow-hidden rounded-lg border-2 border-cinnamon/30 bg-white" data-id="element-45" data-mp="203suwu7vaob9" data-mpi={index}>
                <h3 data-id="element-46" data-mp="1v5raa4usmgxo">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-3.5 py-2.5 text-left text-sm font-extrabold normal-case tracking-normal text-espresso sm:text-base" data-id="element-47" data-mp="1v46hajo4n61x">
                    {faq.question}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-burnt transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-48" data-mp="1pmb8somiald5" />
                  </button>
                </h3>
                {isOpen ? <p className="border-t border-cinnamon/20 px-3.5 py-2.5 text-sm font-medium leading-snug text-espresso/85" data-id="element-49" data-mp="16oh4gnwboy13">
                    {faq.answer}
                  </p> : null}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}